import React, { Fragment } from "react";
import Footer from "./Footer";
import D2T from "./D2T";

const Trennbares = () => {
  const FOOTER1 = {
    Title: "مثال‌های بیشتر",
    Type: "Trennbares ",
    Examples: {
      1: ["Ich rufe dich an.", "من به تو زنگ می‌زنم"],
      2: ["Wir rufen sie morgen an. ", "ما فردا به او زنگ می‌زنیم"],
    },
  };
  const ST1 = ["ab-", "abfahren - حرکت کردن"];
  const ST2 = ["ab-", "abholen - رفتن و آوردن"];
  const ST3 = ["an-", "anrufen -  تماس پرفتن"];
  const ST4 = ["an-", "ankommen - رسیدن"];
  const ST5 = ["auf-", "aufstehen -  بلند شدن، بیدار شدن"];
  const ST6 = ["auf-", "aufmachen - باز کردن"];
  const ST7 = ["aus-", "ausgehen -  بیرون رفتن"];
  const ST8 = ["aus-", "ausmachen - خاموش کردن"];
  const ST9 = ["bei-", "beibringen -  یاد دادن"];
  const ST10 = ["bei-", "beistehen - حمایت کردن"];
  const ST11 = ["ein-", "einladen -  دعوت دادن"];
  const ST12 = ["ein-", "einschlafen - به خواب رفتن"];
  const ST13 = ["fern-", "fernsehen - تلویزیون تماشا کردن"];
  const ST14 = ["mit-", "mitkommen - همراه آمدن"];
  const ST15 = ["mit-", "mitmachen - همراهی کردن"];
  const ST16 = ["nach-", "nachdenken - فکر کردن درباره‌ی چیزی"];
  const ST17 = ["vor-", "vorstellen - معرفی کردن"];
  const ST18 = ["vor-", "vorhaben - برنامه داشتن"];
  const ST19 = ["weg-", "weggehen - رفتن، ترک کردن"];
  const ST20 = ["weg-", "wegnehmen - گرفتن، دور کردن"];
  const ST21 = ["weiter-", "weitermachen - ادامه دادن"];
  const ST22 = ["zu-", "zumachen - بستن"];
  const ST23 = ["zu-", "zuhören - گوش دادن"];
  const ST24 = ["zurück-", "zurückkommen - بازگشتن"];
  const ST25 = ["zusammen-", "zusammenarbeiten - همکاری کردن"];
  const ST26 = ["zusammen-", "zusammenkommen - دور هم جمع شدن"];

  return (
    <Fragment>
      <Footer FOOTER={FOOTER1} />
      <span style={{ marginTop: "25px", fontWeight: "bolder" }}>
        افعال جداشدنی (Trennbare Verben) در زبان آلمانی{" "}
      </span>
      <span style={{ marginTop: "10px" }}>
        افعال جداشدنی (Trennbare Verben) در زبان آلمانی افعال جداشدنی در آلمانی،
        افعالی هستند که شامل یک پیشوند (Präfix) قابل جدا شدن از فعل اصلی هستند.
        هنگام صرف این افعال در جمله‌های خبری (در زمان حال و گذشته ساده)، پیشوند
        به انتهای جمله منتقل می‌شود.
      </span>
      <span>✅ رایج‌ترین پیشوندهای جداشدنی</span>
      <D2T
        ST1={ST1}
        ST2={ST2}
        T1="abfaGHen"
        T2="abHolen"
        MT="25px"
        Bac="#fafdc4"
      />
      <D2T ST1={ST3} ST2={ST4} T1="anGhoofen" T2="anKommen" MT="0" Bac="" />
      <D2T
        ST1={ST5}
        ST2={ST6}
        T1="afSHdihin"
        T2="aufmaKHen"
        MT="0"
        Bac="#fafdc4"
      />
      <D2T ST1={ST7} ST2={ST8} T1="ausgehen" T2="ausmakhen" MT="0" Bac="" />
      <D2T
        ST1={ST9}
        ST2={ST10}
        T1="baibekhingen"
        T2="baiSH-tehen"
        MT="0"
        Bac="#fafdc4"
      />
      <D2T ST1={ST11} ST2={ST12} T1="ainladen" T2="ainSh-Lafen" MT="0" Bac="" />
      <D2T ST1={ST13} ST2={null} T1="fianZehin" T2="" MT="0" Bac="#fafdc4" />
      <D2T ST1={ST14} ST2={ST15} T1="mitkomen" T2="mitmakhen" MT="0" Bac="" />
      <D2T ST1={ST16} ST2={null} T1="nakhdinkenfo" T2="" MT="0" Bac="#fafdc4" />
      <D2T ST1={ST17} ST2={ST18} T1="foshtelen" T2="fohaben" MT="0" Bac="" />
      <D2T
        ST1={ST19}
        ST2={ST20}
        T1="vek-gehin"
        T2="vek-nimen"
        MT="0"
        Bac="#fafdc4"
      />
      <D2T ST1={ST21} ST2={null} T1="vaitamakhen" T2="" MT="0" Bac="" />
      <D2T
        ST1={ST22}
        ST2={ST23}
        T1="soomakhen"
        T2="sooHoghen"
        MT="0"
        Bac="#fafdc4"
      />
      <D2T ST1={ST24} ST2={null} T1="sooghookKammen" T2="" MT="0" Bac="" />
      <D2T
        ST1={ST25}
        ST2={ST26}
        T1="soozamenabaiten"
        T2="soozamenkommen"
        MT="0"
        Bac="#fafdc4"
      />
    </Fragment>
  );
};

export default Trennbares;
